import type { FileImageUsage } from '@vedalib/editor/lib/files'
import { FileUsageTypeEnum } from '@vedalib/editor/lib/files'
import cn from 'classnames'

import { getUrlMedia } from 'components/Editor/EditorElements/utils/getUrlImage'
import type { KeyIconsType } from 'components/uiKit/Icon'
import Icon from 'components/uiKit/Icon'
import type { KitSize } from 'components/uiKit/KitTypes'
import { getFileByUsage } from 'utils/files'

import * as s from './PanelIconImage.module.scss'

interface IPanelIconImageProps {
  file?: Omit<FileImageUsage, 'type'> | null
  defaultPath?: string
  icon?: KeyIconsType
  iconStyle?: React.CSSProperties
  iconSize?: KitSize | number
  hasValue?: boolean
}

const PanelIconImage: React.FC<IPanelIconImageProps> = ({
  file,
  defaultPath,
  icon,
  iconStyle,
  iconSize = 12,
  hasValue,
}) => {
  const path =
    (file && getUrlMedia(file, getFileByUsage(file, FileUsageTypeEnum.image)?.path)) || defaultPath

  if (path) {
    return <img className={s.img} src={path} />
  }

  if (icon) {
    return (
      <div className={cn(s.icon, { [s.gradient]: hasValue })} style={iconStyle}>
        <Icon name={hasValue ? 'energy' : icon} size={iconSize} />
      </div>
    )
  }

  return null
}

export default PanelIconImage
